import { createApi } from "@reduxjs/toolkit/query/react";
import { MODIFIER_OPTION, HttpMethod, TagId, TagType } from "../../data/constants";
import { createBaseQuery } from "../helpers/baseQueryHelper";
import { ModifierOption } from "../../data/interfaces";

const modifierOptionApi = createApi({
  reducerPath: MODIFIER_OPTION.reducerPath,
  baseQuery: createBaseQuery(MODIFIER_OPTION.baseUrl),
  tagTypes: MODIFIER_OPTION.tagTypes,
  endpoints(builder) {
    return {
      getMyModifierOptions: builder.query<ModifierOption[], void>({
        query: () => ({
          url: "/my-modifier-options",
          method: HttpMethod.GET,
        }),
        providesTags: () => [{ type: TagType.ModifierOption, id: TagId.LIST }],
      }),
      toggleModifierOptionStock: builder.mutation<
        void,
        { modifierOptionId: string; haveStock: boolean }
      >({
        query: ({ modifierOptionId, haveStock }) => ({
          url: `/${modifierOptionId}/stock`,
          method: HttpMethod.PATCH,
          params: { haveStock },
        }),
        invalidatesTags: [{ type: TagType.ModifierOption, id: TagId.LIST }],
      }),
    };
  },
});

export const {
  useGetMyModifierOptionsQuery,
  useToggleModifierOptionStockMutation,
} = modifierOptionApi;

export { modifierOptionApi };
